module.exports = __webpack_public_path__ + "static/media/WhyPeopleTravel_main.2d647dad.jpg";